export default "__VITE_ASSET__CzVm1Wg$__"